import { useMemo } from 'react';

import { ISimpleSelectItem, SimpleSelect } from '../../../components/select/SimpleSelect';
import { useAuth } from '../../../contexts/auth-context';
import { InternalRole } from '../../auth/endpoints/MeEndpoint.types';
import { roleToNumber } from '../../auth/roles.client';

const OPTIONS: ISimpleSelectItem[] = Object.entries(InternalRole).map(([key, value]) => ({
  key: value,
  name: key,
}));

export interface IRoleSelectProps {
  onSelect: (role: string) => void;
  value: string;
  isDisabled?: boolean;
}

export const RoleSelect: React.FC<IRoleSelectProps> = (props) => {
  const { onSelect, value, isDisabled } = props;
  const { me } = useAuth();

  // The server rejects granting a role above your own, so don't offer those.
  // The currently assigned role stays listed even when it outranks the viewer,
  // otherwise the select would render as empty.
  const items = useMemo(() => {
    const maxRank = roleToNumber(me.role);
    return OPTIONS.filter((option) => option.key === value || roleToNumber(option.key as InternalRole) <= maxRank);
  }, [me.role, value]);

  return (
    <SimpleSelect
      isDisabled={isDisabled}
      items={items}
      onSelect={(val) => {
        if (val) {
          onSelect(val.key);
        }
      }}
      selectedItem={items.find((v) => v.key === value) ?? null}
    />
  );
};
